import GenericGridCreator from 'ps-components/AdvancedTable/GenericGrid/GenericGridCreator';
import { JobDetails } from 'ps-components/AdvancedTable/GenericGrid/GenericGridCellRenderers';
import { JobMatchDetail } from '../JobMatchDetail/JobMatchDetailRenderer';
import addAlert from 'ps-components/AlertToast/addAlert';
const LANDING_PAGE_SET_ADVANCED_FILTERS = 'LANDING_PAGE_SET_ADVANCED_FILTERS';
const LANDING_PAGE_CLEAR_ADVANCED_FILTERS = 'LANDING_PAGE_CLEAR_ADVANCED_FILTERS';
const LANDING_PAGE_SET_SEARCH_MODE = 'LANDING_PAGE_SET_SEARCH_MODE';
const LANDING_PAGE_CLEAR_SORT = 'LANDING_PAGE_CLEAR_SORT';
const LANDING_PAGE_GG_SEARCH_ERROR = 'LANDING_PAGE_GG_SEARCH_ERROR';
export const NAMESPACE = 'LANDING_PAGE';

const newGenericGrid = new GenericGridCreator(
  NAMESPACE,
  {},
  {
    addedFilters: [],
    orderBy: [],
    searchMode: localStorage.getItem('landing-page__facet-panel_search_mode') === 'true' ? 'facet' : 'advanced',
    defaultLeftColumns: [
      {
        Header: '',
        id: 'job-match-details',
        stickyLeft: true,
        component: JobMatchDetail,
        width: 50,
        accessor: null
      },
      {
        Header: 'Job Title',
        id: 'org_job_title',
        stickyLeft: true,
        customRender: JobDetails,
        width: 260,
        canSort: true,
        accessor: null
      }
    ],
    hiddenTerms: [
      'field_org_job_code',
      'field_org_job_code_key',
      'field_org_job_title',
      'org_job_id_default',
      'org_job_code_default',
      'org_job_code_key_default',
      'org_job_description_default'
    ],
    tableProps: {
      useSelectAll: false
    }
  },
  {
    getInstanceState: store => store.landingPage.landingPageGridReducer
  }
);
export const landingPageGridActions = newGenericGrid.getActions();

landingPageGridActions.setAdvancedFilters = (filters, localStorageKey, availableColumns) => {
  return dispatch => {
    const cleanedFilters = filters.filter(
      filter =>
        (!availableColumns || availableColumns.includes(filter.field)) &&
        filter.field &&
        filter.operator &&
        filter.value
    );
    if (cleanedFilters.length < filters.length)
      addAlert(
        [
          'Some filters were not applied due to being invalid.',
          'Please make sure you fill out each of the 3 fields for each filter.'
        ],
        'warning',
        4000
      );
    if (cleanedFilters.length) cleanedFilters[0].canDelete = false;
    if (localStorageKey) localStorage.setItem(localStorageKey, JSON.stringify(cleanedFilters));
    return dispatch({
      type: LANDING_PAGE_SET_ADVANCED_FILTERS,
      filters: cleanedFilters
    });
  };
};

landingPageGridActions.clearAdvancedFilters = () => {
  return dispatch => {
    return dispatch({
      type: LANDING_PAGE_CLEAR_ADVANCED_FILTERS
    });
  };
};

landingPageGridActions.setSearchMode = mode => {
  return dispatch => {
    return dispatch({
      type: LANDING_PAGE_SET_SEARCH_MODE,
      mode
    });
  };
};

landingPageGridActions.clearSort = () => {
  return dispatch => {
    return dispatch({
      type: LANDING_PAGE_CLEAR_SORT
    });
  };
};

function extendReducer(state, action) {
  switch (action.type) {
    case LANDING_PAGE_SET_ADVANCED_FILTERS:
      return {
        ...state,
        addedFilters: action.filters
      };
    case LANDING_PAGE_SET_SEARCH_MODE:
      return {
        ...state,
        searchMode: action.mode
      };
    case LANDING_PAGE_CLEAR_ADVANCED_FILTERS:
      return {
        ...state,
        addedFilters: []
      };
    case LANDING_PAGE_CLEAR_SORT:
      return {
        ...state,
        orderBy: []
      };
    case LANDING_PAGE_GG_SEARCH_ERROR:
      return {
        ...state,
        data: [],
        tableProps: {
          ...state.tableProps,
          totalCount: 0,
          rowData: [],
          columnHeaders: [],
          noDataText: 'Error loading data',
          dataLoading: false
        },
        metadata: {
          ...state.metadata,
          totalCount: 0
        }
      };
    default:
      return null;
  }
}

export default newGenericGrid.createReducer(extendReducer);
